import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';

import medical_pic from '../assets/photos/medical_equipments/18.jpg';
import promo_pic from '../assets/photos/promotional_materials/12.jpg';
import education_pic from '../assets/photos/educational_solutions/1.jpg';
import moble_pic from '../assets/photos/smart_mobile/2.jpg';
import realestate_pic from '../assets/photos/real_estate/3.jpg';
import telecom_pic from '../assets/photos/telecom_solutions/6.jpg';
import ict_pic from '../assets/photos/ict_solutions/1.jpg';
import agri_pic from '../assets/photos/agricultular_solutions/6.jpg';
import energ_pic from '../assets/photos/energy_solutions/1.jpg';
import green_pic from '../assets/photos/energy_solutions/3.jpg';

import d1 from '../assets/photos/medical_equipments/1.jpg';
import d2 from '../assets/photos/medical_equipments/2.jpg';
import d3 from '../assets/photos/medical_equipments/3.jpg';
import d4 from '../assets/photos/medical_equipments/4.jpg';
import d5 from '../assets/photos/medical_equipments/5.jpg';
import d6 from '../assets/photos/medical_equipments/6.jpg';
import d7 from '../assets/photos/medical_equipments/7.jpg';
import d8 from '../assets/photos/medical_equipments/8.jpg';
import d9 from '../assets/photos/medical_equipments/9.jpg';
import d10 from '../assets/photos/medical_equipments/10.jpg';
import d11 from '../assets/photos/medical_equipments/11.jpg';
import d12 from '../assets/photos/medical_equipments/12.jpg';
import d13 from '../assets/photos/medical_equipments/13.jpg';
import d14 from '../assets/photos/medical_equipments/14.jpg';
import d15 from '../assets/photos/medical_equipments/15.jpg';
import d16 from '../assets/photos/medical_equipments/16.jpg';
import d17 from '../assets/photos/medical_equipments/17.jpg';
import d18 from '../assets/photos/medical_equipments/18.jpg';
import d19 from '../assets/photos/medical_equipments/19.jpg';
import d20 from '../assets/photos/medical_equipments/20.jpg';
import d21 from '../assets/photos/medical_equipments/21.jpg';
import d22 from '../assets/photos/medical_equipments/22.jpg';
import d23 from '../assets/photos/medical_equipments/23.jpg';
import d24 from '../assets/photos/medical_equipments/24.jpg';
import d25 from '../assets/photos/medical_equipments/25.jpg';
import d26 from '../assets/photos/medical_equipments/26.jpg';
import d27 from '../assets/photos/medical_equipments/27.jpg';
import d28 from '../assets/photos/medical_equipments/28.jpg';
import d29 from '../assets/photos/medical_equipments/29.jpg';
import d30 from '../assets/photos/medical_equipments/30.jpg';
import d31 from '../assets/photos/medical_equipments/31.jpg';
import d32 from '../assets/photos/medical_equipments/32.jpg';


import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">
										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
												textTransform: "uppercase",
											}}
										>
											Medical Equipments
										</h1>
	
										
	
									</div>
	
									
	
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">
								<img
									src={medical_pic}
									style={{
										width: "100%"
									}}
								/>
								<h6
									style={{
										fontSize: "18px",
										marginTop: "20px",
										marginBottom: "20px",
									}}
								>
									JIEZHI TECH CO LTD is the reliable partner you can count on to provide cutting-edge medical equipment that is highly beneficial to patients and healthcare facilities. Our commitment to innovation and quality at JIEZHI TECH CO LTD drives us to continuously develop advanced medical equipment that meets the evolving needs of the healthcare industry. We understand the importance of delivering reliable and effective solutions that enhance patient care and improve operational efficiency in healthcare settings.
								</h6>

								<HorizontalImageStrip
									images={[d1, d2, d3]}
								/>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									DIAGNOSTIC EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d25}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									We understand the critical importance of diagnostic equipment in accurately assessing patients’ conditions and guiding treatment decisions. That’s why we provide state-of-the-art X-ray machines, MRI scanners, CT scanners, ultrasound machines, and a variety of other diagnostic tools to ensure healthcare professionals have access to the latest technology for accurate diagnosis.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									SURGICAL EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d18}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									In the operating room, precision and reliability are paramount. That’s why we supply surgical equipment of the highest caliber, including scalpels, forceps, scissors, surgical drills, operating lamps, operating tables, anesthesia machines, and advanced surgical lasers. Our products are designed to enhance surgical precision and efficiency, enabling surgeons to deliver optimal outcomes for their patients.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									LIFE SUPPORT EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d2}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Life support equipment plays a crucial role in saving lives and stabilizing patients in critical conditions. That’s why we offer a comprehensive range of life support devices, including ventilators, defibrillators, cardiac monitors, and infusion pumps. Our equipment is engineered to deliver reliable performance and ensure patient safety in emergency and intensive care settings.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									LABORATORY EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d7}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									In the laboratory, precision and accuracy are paramount for reliable test results. That’s why we offer laboratory equipment such as microscopes, centrifuges, incubators, spectrophotometers, and blood analyzers, designed to meet the stringent requirements of modern medical laboratories.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									HOSPITAL FURNITURE
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d14}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our company provides high-quality hospital furniture including beds, chairs, tables, cabinets, and examination tables designed for patient comfort, caregiver efficiency, and facility organization. The furniture is crafted with durability and functionality in mind to enhance patient care in healthcare facilities.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									OB/GYN EQUIPMENT
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d24}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our company specializes in providing a comprehensive range of high-quality OB/GYN equipment to meet the diverse needs of obstetricians and gynecologists worldwide. Our selection includes advanced ultrasound machines for fetal monitoring, colposcopes for cervical examination, fetal dopplers for heart rate monitoring, and electrosurgical units for precise surgical interventions.
									Additionally, we offer a variety of speculums, biopsy forceps, and other essential hand tools to support healthcare professionals in delivering exceptional care to their patients. With a focus on innovation, reliability, and patient safety, our OB/GYN equipment is designed to enhance diagnostic accuracy, improve patient outcomes, and streamline clinical workflows, making us a trusted partner in women’s healthcare.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									DENTAL EQUIPMENTS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d17}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									As a leading healthcare supplier, we offer a comprehensive range of dental equipment for professionals. Our products include dental chairs for comfort, digital radiography systems for precise imaging, autoclaves for cleanliness, and dental handpieces for precision. We aim to enhance dental care with advanced technology and user-friendly design.
								</h6>
							</div>

							<div className="col-md-6 mt-3 mb-4">
								<h6
									className="main-section-title"
								>
									X-RAY RADIOGRAPHY SYSTEMS
								</h6>

								<img
									style={{
										width: "100%",
										height: "auto",
										display: "block",
									}}
									src={d6}
								/>	

								<h6
									style={{
										fontSize: "16px",
										borderLeft: "10px solid var(--primaryColor)",
										paddingLeft: "10px"
									}}
								>
									Our company is proud to supply state-of-the-art X-ray Radiography Systems designed to meet the diverse needs of healthcare facilities. Our product lineup includes advanced Digital Radiography (DR) systems, versatile Mobile X-ray units for bedside imaging, and specialized Fluoroscopy systems for real-time imaging of patients’ internal structures. Each system is equipped with cutting-edge technology to ensure high-resolution images, enabling precise diagnosis and treatment planning.
								</h6>
							</div>
	
						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}